import { useEffect } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import config from "../config/config";

export function useSessionSocket(onUpdate) {
  useEffect(() => {
    const client = new Client({
      webSocketFactory: () => new SockJS(config.BROADCAST_SOCKET_URL),
      reconnectDelay: 5000,
    });

    client.onConnect = () => {
      console.log("✅ STOMP connected");
      client.subscribe("/topic/session‑updates", ({ body }) => {
        const updated = JSON.parse(body);
        console.log("🔄 Received session update:", updated);
        onUpdate(updated);
      });
    };

    client.onWebSocketError = (err) => {
      console.error("⚠️ WS error", err);
    };

    client.onStompError = (frame) => {
      console.error("⚠️ STOMP error", frame);
    };

    client.activate();
    return () => {
      client.deactivate();
      console.log("🛑 STOMP disconnected");
    };
  }, [onUpdate]);
}
